import de from '@scantrust/translations-web-photo/locales/de.json'
import en from '@scantrust/translations-web-photo/locales/en.json'
import es from '@scantrust/translations-web-photo/locales/es.json'
import fr from '@scantrust/translations-web-photo/locales/fr.json'
import hi from '@scantrust/translations-web-photo/locales/hi-IN.json'
import id from '@scantrust/translations-web-photo/locales/id.json'
import it from '@scantrust/translations-web-photo/locales/it.json'
import ja from '@scantrust/translations-web-photo/locales/ja.json'
import ko from '@scantrust/translations-web-photo/locales/ko.json'
import nl from '@scantrust/translations-web-photo/locales/nl.json'
import th from '@scantrust/translations-web-photo/locales/th.json'
import zh from '@scantrust/translations-web-photo/locales/zh.json'
import fa from '@scantrust/translations-web-photo/locales/fa.json'
import tw from '@scantrust/translations-web-photo/locales/zh-TW.json'
import vi from '@scantrust/translations-web-photo/locales/vi.json'

export default {
  messages: {
    de: de,
    en: en,
    es: es,
    fr: fr,
    hi: hi,
    id: id,
    it: it,
    ja: ja,
    ko: ko,
    nl: nl,
    th: th,
    vi: vi,
    zh: zh,
    fa: fa,
    tw: tw
  }
}
